export const headers = { 'Content-Type': 'application/json' };

export const URL_BASE = '/api';
export const URL_AUTH = `${URL_BASE}/auth`;
export const URL_ADMIN = `${URL_BASE}/admin`;
export const URL_DATASET = `${URL_BASE}/dataset`;
export const URL_PUBLIC_DATASET = `${URL_BASE}/public-datasets`;
export const URL_MODEL = `${URL_BASE}/model`;
export const URL_SUPPORT = `${URL_BASE}/support`;
